// UI and SEO text, one JSON file per language in public/content/i18n/
// (<code>.json), accessed via dot-notation keys. backend/app.py reads the
// same files for page titles, the FAQ and emails. See README.md in this folder.
import { LOCALES } from './locales';

const files = require.context('../../public/content/i18n', false, /^\.\/[a-z]{2}\.json$/);

export default LOCALES.reduce((all, code) => {
  all[code] = files(`./${code}.json`);
  return all;
}, {});
